<template>
  <b-card :validated="formValidated">
    <div :style="{ position: 'absolute', top: 0, right: 0, display: 'flex', flexBasis: 'auto', backgroundColor: 'var(--bs-card-border-color)', borderRadius: '4px' }">
      <!-- NOTE: slot for delete button -->
      <slot />
    </div>
    <b-row align-h="center" align-v="end" class="mt-4">
      <b-col cols="12" sm="6" lg="3" class="flex-grow-1">
        <b-form-group class="mb-3"
          :label="formConfig.first_name.label"
          :label-for="formConfig.first_name.id"
          :state="stateFirstName"
        >
          <!-- :validated="formValidated" -->
          <b-form-input
            :state="stateFirstName"
            v-bind="formConfig.first_name"
            v-model="formData.first_name"
            :value="formConfig.first_name"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="6" lg="3" class="flex-grow-1">
        <b-form-group class="mb-3"
          :label="formConfig.last_name.label"
          :label-for="formConfig.last_name.id"
          :state="stateLastName"
        >
          <!-- :validated="formValidated" -->
          <b-form-input
            :state="stateLastName"
            v-bind="formConfig.last_name"
            v-model="formData.last_name"
            :value="formConfig.last_name"
          />
        </b-form-group>
      </b-col>
      <b-col cols="9" lg="auto">
        <b-form-group class="mb-3"
          :label="formConfig.date_of_birth.label"
          :label-for="formConfig.date_of_birth.id"
          :state="stateDateOfBirth"
        >
          <!-- :validated="formValidated" -->
          <DropdownDatepicker class="btb-datepicker"
            :state="stateDateOfBirth"
            v-bind="minorDateOfBirthConfig"
            v-model="formData.date_of_birth"
            :defaultDate="minor.date_of_birth"
          />
        </b-form-group>
      </b-col>
      <b-col cols="3" lg="auto" class="flex-shrink-1">
        <label class="mb-3"
          :style="{ display: 'flex', alignItems: 'center', flexDirection: 'column-reverse' }"
        >
          <input class="btb-checkbox-lg"
            type="checkbox"
            v-bind="formConfig.playing"
            v-model="formData.isPlayer"
          />
          <span :style="{ ...(!isTablet && { marginLeft: '1rem' }) }" :class="isTablet && 'pb-2'">{{ formConfig.playing.label }}</span>
        </label>
        <!-- </b-form-group> -->
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { SELECTED_RESERVATION } from '@/store/state'
import DropdownDatepicker from 'vue-dropdown-datepicker'

export default {
  inject: ['mediaQueries'],
  components: {
    DropdownDatepicker
  },
  props: {
    minor: {
      type: Object
    }
  },
  data () {
    return {
      formConfig: {
        playing: {
          id: 'minor-playing',
          label: 'Playing today?',
          name: 'minor-playing',
          size: 'lg',
          // value: true,
          // 'unchecked-value': false,
          value: '1',
          'unchecked-value': '0',
        },
        first_name: {
          id: 'minor-firstname',
          label: 'First Name',
          placeholder: 'Minor\'s First Name',
          required: true,
          type: 'text'
        },
        last_name: {
          id: 'minor-lastname',
          label: 'Last Name',
          placeholder: 'Minor\'s Last Name',
          required: true,
          type: 'text'
        },
        date_of_birth: {
          label: 'Minor\'s Date of Birth',
          daySuffixes: false,
          displayFormat: "ymd", 
          minAge: 8,
          maxAge: 18,
          required: true,
        }
      },
      formData: {
        isPlayer: this.minor.isPlayer,
        first_name: this.minor.first_name,
        last_name: this.minor.last_name,
        date_of_birth: this.minor.date_of_birth,
      },
      formValidated: false
    }
  },
  computed: {
    isTablet () {
      return !this.mediaQueries.xs && !this.mediaQueries.sm
    },
    ...mapState([
      SELECTED_RESERVATION,
    ]),
    stateFirstName () {
      return this.formValidated ? !!this.formData.first_name?.length : null
    },
    stateLastName () {
      return this.formValidated ? !!this.formData.last_name?.length : null
    },
    stateDateOfBirth () {
      return this.formValidated ? !!this.formData.date_of_birth?.length : null
    },
    minorDateOfBirthConfig () {
      const missionId = Number(this[SELECTED_RESERVATION]?.mission_id)
      const minAge = [16, 18, 19].includes(missionId) ? 6 : this.formConfig.date_of_birth.minAge

      return {
        ...this.formConfig.date_of_birth,
        minAge,
      }
    },
  },
  watch: {
    formData: { 
      handler: function (fresh) {
        this.$emit('input', fresh);
      },
      deep: true,
    }
  },
  methods: {
    validateForm () {
      this.formValidated = true
      const { first_name, last_name, date_of_birth } = this.formData
      return !!(first_name && last_name && date_of_birth)
    }
  }
}
</script>

<style lang="scss" scoped>
.btb-checkbox-lg {
  width: 2.25rem;
  height: 2.25rem;
}
</style>